var _g, _path, _path2, _path3, _path4, _path5, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_18_2361)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.4489 0C39.5519 0 51.0039 11.452 51.0039 25.4489C51.0039 39.5519 39.5519 51.0039 25.4489 51.0039C11.452 51.0039 0 39.5519 0 25.4489C0 11.452 11.452 0 25.4489 0ZM25.4489 5.61996C14.5271 5.61996 5.61998 14.5271 5.61998 25.4489C5.61998 36.4768 14.5271 45.3839 25.4489 45.3839C36.4768 45.3839 45.3839 36.4768 45.3839 25.4489C45.3839 14.5271 36.4768 5.61996 25.4489 5.61996Z",
    fill: "url(#paint0_linear_18_2361)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.577 45.7263C20.1987 45.7263 15.1309 43.6304 11.3272 39.8268C7.52361 36.0232 5.42773 30.9664 5.42773 25.577C5.42773 20.1987 7.52361 15.142 11.3272 11.3383C15.1309 7.52362 20.1987 5.42773 25.577 5.42773C30.9553 5.42773 36.0232 7.52362 39.8268 11.3383C43.6304 15.142 45.7263 20.1987 45.7263 25.577C45.7263 30.9664 43.6304 36.0232 39.8268 39.8268C36.0232 43.6304 30.9553 45.7263 25.577 45.7263Z",
    fill: "url(#paint1_linear_18_2361)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.6,
    d: "M23.7594 34.4619C19.5454 34.6726 15.5754 33.4417 12.6035 31.002C9.62046 28.5513 7.97925 25.1801 7.97925 21.5096C7.97925 17.839 9.62046 14.3015 12.6035 11.5514C15.5754 8.8123 19.5454 7.17108 23.7594 6.96038C27.9733 6.74969 31.9433 7.9806 34.9263 10.4202C37.8982 12.871 39.5505 16.2421 39.5505 19.9127C39.5505 23.5833 37.8982 27.1208 34.9263 29.8709C31.9433 32.61 27.9733 34.2401 23.7594 34.4619Z",
    fill: "url(#paint2_linear_18_2361)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M22.4159 32.0536C16.5607 32.0536 11.0383 30.1684 6.87976 26.7529C7.50076 30.1795 9.25288 33.3288 11.9476 35.8461C15.3853 39.0287 19.9208 41.0803 24.7779 41.0803C29.635 41.0803 34.2149 39.0287 37.6415 35.8461C41.0681 32.6524 42.9644 28.4163 42.9644 23.914C42.9644 22.927 42.8757 21.9512 42.6983 20.9975C40.2032 29.869 28.3154 32.0536 22.4159 32.0536Z",
    fill: "url(#paint3_linear_18_2361)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.7263 25.577C45.7263 30.9664 43.6304 36.0232 39.8268 39.8268C36.0232 43.6304 30.9553 45.7263 25.577 45.7263C20.1987 45.7263 15.1309 43.6304 11.3272 39.8268C7.52361 36.0232 5.42773 30.9664 5.42773 25.577C5.42773 20.1987 7.52361 15.142 11.3272 11.3383C15.1309 7.52362 20.1987 5.42773 25.577 5.42773C30.9553 5.42773 36.0232 7.52362 39.8268 11.3383C43.6304 15.142 45.7263 20.1987 45.7263 25.577ZM43.1092 24.0578C43.1092 19.367 41.2019 14.9645 37.7531 11.6599C34.2932 8.34423 29.7023 6.52558 24.8119 6.52558C19.9326 6.52558 15.3305 8.34423 11.8817 11.6599C8.42184 14.9645 6.51449 19.367 6.51449 24.0578C6.51449 28.7375 8.54384 32.9625 12.0037 36.2782C15.4525 39.5828 20.0434 41.4126 24.9338 41.4126C29.8242 41.4126 34.4152 39.5828 37.8751 36.2782C41.3239 32.9625 43.1092 28.7375 43.1092 24.0578Z",
    fill: "url(#paint4_linear_18_2361)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M38.6396 37.2193C35.1797 40.535 30.5554 42.6752 25.0995 42.5643C20.2202 42.4645 11.9698 40.2466 6.87976 32.972C7.03501 34.1586 9.64101 38.6054 11.8145 40.3021C15.5627 43.8063 20.4198 45.7248 25.5763 45.7248C30.9547 45.7248 36.0225 43.6289 39.8261 39.8252C43.6298 36.0216 45.7256 30.9649 45.7256 25.5755C45.7256 24.9397 45.6961 24.3113 45.6369 23.6903C45.6258 22.3041 44.7054 18.7666 44.1066 17.5801C45.7256 28.37 42.0883 33.9036 38.6396 37.2193Z",
    fill: "url(#paint5_radial_18_2361)"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2648 8.63603C18.923 8.30335 16.4168 9.94457 16.3392 10.8872C16.2394 12.1292 17.936 11.9074 19.7547 10.9648C21.2074 10.2107 21.1408 8.85782 20.2648 8.63603Z",
    fill: "#E5FFFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9202 12.5325C12.9443 12.6101 12.2235 13.3753 12.3898 14.0185C12.6005 14.8724 13.5099 14.7393 14.2085 14.0407C15.018 13.2422 14.5523 12.4881 13.9202 12.5325Z",
    fill: "#E5FFFF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_18_2361)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_18_2361",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 15,
    width: 24,
    height: 21
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1868 15.2V22.2755H21.0089V17.022H32.528L24.4678 21.2055V29.5809L32.528 33.7643H21.0089V28.359H19.1868V35.5863H36V15.2H19.1868Z",
    fill: "url(#paint6_linear_18_2361)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9886 26.4965V24.2898H17.3952V21.3949L12 25.3932L17.3952 29.3915V26.4965H20.9886Z",
    fill: "url(#paint7_linear_18_2361)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_18_2361)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_di_18_2361)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.1869 15.2V22.2755H21.0089V17.022H32.5281L24.4678 21.2055V29.5809L32.5281 33.7643H21.0089V28.359H19.1869V35.5863H36V15.2H19.1869Z",
    fill: "url(#paint8_linear_18_2361)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9886 26.4965V24.2898H17.3952V21.3948L12 25.3931L17.3952 29.3915V26.4965H20.9886Z",
    fill: "url(#paint9_linear_18_2361)"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.1786,
    cy: 12.1134,
    rx: 22.1208,
    ry: 13.3754,
    fill: "#FBDB6B",
    fillOpacity: 0.2
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_18_2361",
    x: 0,
    y: 0,
    width: 51.0039,
    height: 51.0039,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.95452
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_18_2361"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_18_2361",
    x: 10.9711,
    y: 14.1711,
    width: 26.0578,
    height: 22.4441,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.514438
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_18_2361"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_18_2361",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_di_18_2361",
    x: 8.91337,
    y: 15.2,
    width: 30.1733,
    height: 27.0268,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.5538
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.54331
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_18_2361"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_18_2361",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.514438
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.729412 0 0 0 0 0.34902 0 0 0 0 0.0588235 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_18_2361"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18_2361",
    x1: -0.0241685,
    y1: 50.9822,
    x2: -0.0241685,
    y2: -0.0408374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7513"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.592,
    stopColor: "#FFA600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFED75"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_18_2361",
    x1: 47.5481,
    y1: 16.0971,
    x2: 52.669,
    y2: 46.0912,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A9E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007FC3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_18_2361",
    x1: 35.1169,
    y1: 4.06241,
    x2: 39.0816,
    y2: 21.3627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35B5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_18_2361",
    x1: 19.1963,
    y1: 40.0999,
    x2: 16.9143,
    y2: 24.1258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0072B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_18_2361",
    x1: 31.7623,
    y1: -40.7964,
    x2: 47.5313,
    y2: 11.4043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0072B5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_18_2361",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.6456 41.2704) rotate(-43.196) scale(28.6939)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00639F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_18_2361",
    x1: 20.9896,
    y1: 22.9413,
    x2: 20.9896,
    y2: 28.024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9C849"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED7C18"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_18_2361",
    x1: 20.9896,
    y1: 22.9413,
    x2: 20.9896,
    y2: 28.024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9C849"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED7C18"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_18_2361",
    x1: 36.0019,
    y1: 19.1424,
    x2: 36.0019,
    y2: 32.1001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9C849"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED7C18"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_18_2361",
    x1: 20.9896,
    y1: 22.9412,
    x2: 20.9896,
    y2: 28.024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9C849"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED7C18"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuit);
export default __webpack_public_path__ + "static/media/quit.8c86318790f37a2781430f9c4c802d2e.svg";
export { ForwardRef as ReactComponent };